// extracted by mini-css-extract-plugin
export var contentWrapper = "about-module--content-wrapper--zt+30";